import NotificationsNavTab from "components/notifications/NotificationsNavTab";
import Routes from "routing/Routes";
export const PAGE_NAV_TITLE = "System";
const bindings = {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Overview", titleKey: "navigation:page_navigation.overview", path: Routes.SYSTEM.OVERVIEW },
        {
          description: "Notifications",
          titleKey: "navigation:page_navigation.notifications",
          path: Routes.SYSTEM.NOTIFICATIONS,
          permissions: "notifications:read",
          BadgeComponent: NotificationsNavTab
        }
      ]
    }
  ]
};
export default bindings;
